import { InfographState, WidgetsMap } from 'types/infographTypes';
import { Page } from 'types/pageTypes';

const GET_PAGE_DATA_BY_TEMPLATE_ID_API = '/api/design/getPageDataByE1TemplateId';
const GET_FULL_PAGE_DATA_BY_TEMPLATE_ID_API = '/api/design/getPublicTemplateDesignData';

type GetPageDataResponse = {
  pageData: Page;
  widgetDataMap: WidgetsMap;
}[];

/**
 * Gets E2 page + widget data given an E1 template ID
 *
 * @param templateId E1 template ID
 * @param pageNumbers pages to fetch
 * @returns GetPageDataResponse
 */
export const getPageDataFromTemplateId = async (
  templateId: string,
  pageNumbers: number[],
): Promise<GetPageDataResponse> => {
  const pageData = await fetch(GET_PAGE_DATA_BY_TEMPLATE_ID_API, {
    method: 'POST',
    body: JSON.stringify({
      templateId,
      pages: pageNumbers,
    }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  return pageData.json();
};

/**
 * This API will fetch template design data as InfographState format
 *
 * @param templateId E1 template UUID
 * @returns InfographState
 */
export const getPublicTemplateDesignData = async (templateId: string): Promise<Partial<InfographState>> => {
  const result = await fetch(GET_FULL_PAGE_DATA_BY_TEMPLATE_ID_API, {
    method: 'POST',
    body: JSON.stringify({
      templateId,
    }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  if (!result.ok) throw new Error(await result.text());

  return await result.json();
};
